import HistoryInviteComponent from '@components/history-invite';
import * as React from 'react';

export interface IHistoryInviteProps {}

export default function HistoryInvite(props: IHistoryInviteProps) {
  return <HistoryInviteComponent />;
}
